export default __webpack_public_path__ + "static/media/logo-300x300.4162e4c5.png";